import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function Callback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refresh } = useAuth();

  useEffect(() => {
    const error = searchParams.get('error');
    if (error === 'access_denied') {
      navigate('/access-denied', { replace: true });
      return;
    }

    (async () => {
      // refresh auth state now that the session cookie is set
      try {
        await refresh();
      } catch {
        // ignore
      }
      navigate('/');
    })();
  }, []);

  return <div>Processing authentication...</div>;
}
